import { render, staticRenderFns } from "./GiftPurchasedModal.vue?vue&type=template&id=18faf349&scoped=true&"
import script from "./GiftPurchasedModal.vue?vue&type=script&lang=js&"
export * from "./GiftPurchasedModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftPurchasedModal.vue?vue&type=style&index=0&id=18faf349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18faf349",
  null
  
)

export default component.exports